import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ApiRoutes } from 'src/app/services/apiroutes';

@Injectable({
  providedIn: 'root'
})
export class MyApprovalsService {
  base_url = ApiRoutes.Booking;

  constructor(private http: HttpClient) { }
    getAllApprovals(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<any>> {
      let url = `${this.base_url}grouped_pickup_dropoff_approval/`;
      let urlObj = new URL(url);
      urlObj.searchParams.append('page_size', String(page_size));
      urlObj.searchParams.append('page', String(page));
      urlObj.searchParams.append('search', String(search));
      urlObj.searchParams.append('o', String(order));
      return this.http.get<BackendListModel<any>>(String(urlObj));
    }

      // GET Approval by ID
      getApprovalDetailsById(id: any): Observable<any> {
        let url = `${this.base_url}grouped_pickup_dropoff_approval/${id}/`;
        return this.http.get<any>(url);
      }
}
